import { useNavigationStore } from "@/store/navigationStore";
import Text from "../text/text";
// import VenueMap from "../map/venue-map";
import { useNavigate } from "react-router-dom";
import GoogleMap from "../map/google/google-map";
import { useEffect, useRef } from "react";

export default function HomeException() {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const venueNotSupported = useNavigationStore(
    (state) => state.venueNotSupported
  );
  // const apiError = useNavigationStore((state) => state.apiError);
  // const userQuery = useNavigationStore((state) => state.userQuery);
  let navigate = useNavigate();
  const chatHistory = useNavigationStore(state => state.chatHistory);

  useEffect(() => {
    scrollToBottom();
  }, [chatHistory.length]);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const _buildUserText = (text: string, key: number) => {
    return <div className="flex justify-end mb-[20px]" key={`conversation-${key}`}>
      <Text
        text={text}
        translate={false}
        className="rounded-lg p-[12px] bg-paper-gray"
      />
    </div>
  }

  const _buildBotText = (text: string, key: number) => {
    return <div className="whitespace-pre-wrap break-words mb-[20px]" key={`conversation-${key}`}>
      {text != "" && (
        <Text
          text={text}
          translate={false}
          className="bg-overlay rounded-lg p-[12px]"
        />
      )}
    </div>
  }

  return (
    <div className="flex flex-col">
      {chatHistory.map((chat, key) =>
        chat.from === "user"
          ? _buildUserText(chat.message, key)
          : _buildBotText(chat.message, key)
      )}

      <div className="flex flex-col justify-start mb-[20px] gap-4">
        {venueNotSupported && (
          <div className="venue-map-container w-full flex flex-col p-4">
            <Text text="venue_not_supported" className="pb-[20px]" />
            <Text text="venue_coverage" className="pb-[20px]" />
            <div className="h-[240px]" onClick={() => navigate("/explore/map")}>
              {/* <VenueMap isConstrained={true} /> */}
              <GoogleMap isConstrained={true} />
            </div>
          </div>
        )}
      </div>
      <div ref={messagesEndRef} />
    </div>
  );
}
